angular.module('internal.notifications').filter('notificationIcon', function () {
    return function (type ) {
        switch (type){
            case 'OrderComment':
            case 'EventComment':
                return 'comment';
            case 'Announcement':
                return 'campaign';
           default:
                return 'notifications';

        }
    };
});
